import script from "./CustomQuill.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomQuill.vue?vue&type=script&setup=true&lang=js"

import "./CustomQuill.vue?vue&type=style&index=0&id=0d06e4b7&lang=css"

const __exports__ = script;

export default __exports__